import HowToHeader from '../HowToHeader';
import HowToStep from '../HowToStep';

// Images
import step1Img from './Step 1 Image.png';
import step2Img from './Step 2 Image.png';
import step3Img from './Step 3 Image.png';
import step4Img from './Step 4 Image.png';

// Header
const headerText = `Payment for Your House Share Registration Fee`;
const subtitleText = `Once you have completed the registration process and you are ready to pay your fee, you will see
                        the “Add to Cart” button on your Account Dashboard under the “Action Required” section on the
                        right-hand side.`;

// Steps
const step1Text = `Click “Add to Cart”`;
const step2Text = `Click “1 items in my cart” on the top right-hand side. This number will reflect the number of
                    registrations you have added to your cart to pay for, so the number may be different than 1
                    depending on that.`;
const step3Text = `Click on “Checkout with eCheckout”`;
const step4Text = `Once payment is complete, you will see a screen indicating “Order Confirmed” that verifies the
                    payment processing was successful and no further action is required.`;

const PaymentForRegistration = () => {
  return (
    <>
      <HowToHeader titleText={headerText} subtitleText={subtitleText} />
      <HowToStep stepNumber={1} content={step1Text} imgSrc={step1Img} />
      <HowToStep stepNumber={2} content={step2Text} imgSrc={step2Img} />
      <HowToStep stepNumber={3} content={step3Text} imgSrc={step3Img} />
      <HowToStep stepNumber={4} content={step4Text} imgSrc={step4Img} />
      <p className='mt-4'>
        Shortly after the payment process is complete, your registration number
        will appear in your account.
      </p>
    </>
  );
};

export default PaymentForRegistration;
